import React from 'react';
import useForm from '~/app/modules/form/useForm';
import classes from './style.module.scss';
import MForm from '~/app/modules/form';
import Textarea from '~/app/modules/form/Textarea';
import useTranslation from '~/app/hooks/useTranslation';
import { useWorkOrderHPCodes, useWorkTypes } from '~/app/data/statuses/issue';
import { useStoreState } from '~/store';
import WorkHoursInput from '~/app/modules/form/WorkHoursInput';
import Select from '~/app/modules/form/Select';
import Loader from '~/app/common/Loader';
import { WorkOrderTimeEntryPayload } from '~/workorder/types';

export type DetailsComponent = React.FC;

const Details: DetailsComponent = () => {
  const { t } = useTranslation('issue');
  const { values: formValues, fieldEvents: formFieldEvents, errors } = useForm<WorkOrderTimeEntryPayload>({ formName: 'workOrderTimeEntry' });

  const fetchingWorkTypes = useStoreState(state => state.issue.fetchingWorkTypes);
  const workTypes = useStoreState(state => state.issue.workTypes);
  const workorderTypes = useWorkTypes(workTypes);

  const fetchingHPCodes = useStoreState(state => state.issue.fetchingHPCodes);
  const HPCodes = useStoreState(state => state.issue.HPCodes);
  const issueHpCodes = useWorkOrderHPCodes(HPCodes);
  const isHPCodeRequired = useStoreState(state => state.issue.isHPCodeRequired);

  const fetchingCostCategories = useStoreState(state => state.issue.fetchingCostCategories);
  const costCategories = useStoreState(state => state.issue.costCategories);
  const costCategoryId = useStoreState(state => state.workOrder.data.costCategoryId);
  const selectedCategory = costCategories.find(({ id }) => Number(id) === Number(costCategoryId));

  const overtime1Percentage = selectedCategory?.costData?.overtime1Percentage;
  const overtime2Percentage = selectedCategory?.costData?.overtime2Percentage;

  if (fetchingWorkTypes || fetchingHPCodes || fetchingCostCategories) {
    return <Loader size="16" />;
  }

  return (
    <MForm className={`${classes['form']} ${classes['details']}`}>
      <div className={classes['time-entry-form']}>
        <Textarea
          className={`${classes['input-container']}`}
          placeholder={t('issueClose.comment.placeholder')}
          descriptionPosition="top"
          name="comment"
          defaultValue={formValues.comment as string}
          errors={errors.comment}
          {...formFieldEvents}
        />
        {isHPCodeRequired && <Select
          className={`${classes['input-container']}`}
          name="hpCode"
          placeholder={t('hpCode.placeholder')}
          options={issueHpCodes}
          icon={'keyboard_arrow_down'}
          onChange={formFieldEvents.onChange}
          defaultValue={formValues.hpCode as number}
          showEmptyOption={true}
          emptyOptionValue={0}
        />}
        <WorkHoursInput
          placeholder={t('ordinaryHours.placeholder')}
          name="ordinaryHours"
          defaultValue={formValues.ordinaryHours as string}
          errors={errors.ordinaryHours}
          {...formFieldEvents}
        />
        <WorkHoursInput
          placeholder={overtime1Percentage
            ? t('overTime50.placeholder', { overTime50: overtime1Percentage })
            : t('overTime50.defaultPlaceholder')
          }
          name="overTime50"
          defaultValue={formValues.overTime50 as string}
          errors={errors.overTime50}
          {...formFieldEvents}
        />
        <WorkHoursInput
          placeholder={overtime2Percentage
            ? t('overTime100.placeholder', { overTime100: overtime2Percentage })
            : t('overTime100.defaultPlaceholder')
          }
          name="overTime100"
          defaultValue={formValues.overTime100 as string}
          errors={errors.overTime100}
          {...formFieldEvents}
        />
        <Select
          className={`${classes['input-container']}`}
          name="workType"
          placeholder={t('workType.placeholder')}
          options={workorderTypes}
          icon={'keyboard_arrow_down'}
          onChange={formFieldEvents.onChange}
          defaultValue={formValues.workType as number}
          errors={errors.workType}
          showEmptyOption={true}
          emptyOptionValue={0}
        />
      </div>
    </MForm>
  );
};

export default Details;
